import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

/**
 * This class provides helpers for accessing assets like the default logo.
 */
@Injectable({
    providedIn: 'root',
})
export class AssetUtilsService {
    public static readonly DEFAULT_LOGO_PATH: string = '../../../../../assets/images/timeBuzzer-logo-pdf.png';

    async defaultLogoToBase64(): Promise<string> {
        return fetch(AssetUtilsService.DEFAULT_LOGO_PATH)
            .then((response) => response.blob())
            .then(
                (blob) =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(blob);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- onloadend() API has return type any
                        reader.onloadend = (): any => {
                            // save the default logo in base64 to local storage
                            const base64data = reader.result;
                            LocalStorageService.storeDefaultLogoBase64(base64data as string);
                            resolve(base64data as string);
                        };
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- onerror() API has return type any
                        reader.onerror = (error): any => reject(error);
                    }),
            );
    }
}
